var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"bg"}),_vm._v(" "),_c('v-toolbar-title',{staticClass:"font-weight-bold toolbar",domProps:{"textContent":_vm._s(_vm.appBarText)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }